import axios from "../utils/axios";
import { buildFilterQueryString, buildSortingParams } from "../utils/query";

export const getAgencies = async ({ offset, limit, filters, sortModel } = {}) => {
  const filterQueryString = buildFilterQueryString(filters);
  const sortingParams = buildSortingParams(sortModel);
  const queryParts = [limit && `limit=${limit}`, offset && `offset=${offset}`, filterQueryString, sortingParams].filter(Boolean);
  const url = `/agencies?${queryParts.join("&")}`;
  const { data: agencies } = await axios.get(url);
  return agencies;
};

export const removeAgency = async (agencyId) => {
  const { data: removedAgency } = await axios.delete(`/agencies/${agencyId}`);
  return removedAgency;
};

export const addAgency = async (agency) => {
  const { data: addedAgency } = await axios.post(`/agencies`, {
    data: agency,
  });
  return addedAgency;
};

export const updateAgency = async ({ id, ...agencyData }) => {
  const { data: updatedAgency } = await axios.put(`/agencies/${id}`, {
    data: agencyData,
  });
  return updatedAgency;
};
